import {
  OwnUpFloatingModal,
  OwnUpIconButton,
  OwnUpSmallBodyMedium,
  PropsWithTheme
} from '@rategravity/own-up-component-library';
import { MicroQuestionIcon } from '@rategravity/own-up-component-library/icon-library/system-icons/micro-icons/question';
import React, { useState } from 'react';
import styled from 'styled-components';
import { termsDetails } from './explanationIInfo';

const StyledIcon = styled(OwnUpIconButton)`
  margin-left: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(1)}px;

  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.up('md')} {
    display: none;
  }
`;

export const LabelWithIcon = ({ label }: { label: keyof typeof termsDetails }) => {
  const [openModal, setOpenModal] = useState(false);

  const handleClick = () => {
    setOpenModal(true);
  };

  return (
    <React.Fragment>
      <OwnUpSmallBodyMedium variant="body1">
        {label}
        <StyledIcon icon={<MicroQuestionIcon />} name={label} size={1.125} onClick={handleClick} />
      </OwnUpSmallBodyMedium>
      <OwnUpFloatingModal title={label} open={openModal} onClose={() => setOpenModal(false)}>
        {termsDetails[label]}
      </OwnUpFloatingModal>
    </React.Fragment>
  );
};
